import { Type } from "@angular/core";
import { CategoriesWidgetComponent } from "./categories-widget/categories-widget.component";
import { ConfigsWidgetComponent } from "./configs-widget/configs-widget.component";
import { FeaturesWidgetComponent } from "./features-widget/features-widget.component";
import { PricingWidgetComponent } from "./pricing-widget/pricing-widget.component";
import { ProductsWidgetComponent } from "./products-widget/products-widget.component";
import { PromotionsWidgetComponent } from "./promotions-widget/promotions-widget.component";
import { ReviewsWidgetComponent } from "./reviews-widget/reviews-widget.component";
import { ShippingWidgetComponent } from "./shipping-widget/shipping-widget.component";
import { StoreManagementWidgetComponent } from "./store-management-widget/store-management-widget.component";

export class DynamicWidgetComponent {
    constructor(public component: Type<any>, public link?:string,public data?: any) {}
}
//Store Management
//Catalogue
//Categories
//Products
//Shipping
//Promotions
//Price Rules
//Configurations
//Reviews
//Features
export const dynamicWidgetComponents:any[] = [
    {"name":"CategoriesWidgetComponent"},
    {"name":"ConfigsWidgetComponent"},
    {"name":"FeaturesWidgetComponent"},
    {"name":"PricingWidgetComponent"},
    {"name":"ProductsWidgetComponent"},
    {"name":"PromotionsWidgetComponent"},
    {"name":"ReviewsWidgetComponent"},
    {"name":"ShippingWidgetComponent"},
    {"name":"StoreManagementWidgetComponent"}
]

//,"component":new DynamicWidgetComponent(CategoriesWidgetComponent)}
//"component":new DynamicWidgetComponent(ConfigsWidgetComponent)},
//"component":new DynamicWidgetComponent(FeaturesWidgetComponent)},
//,"component":new DynamicWidgetComponent(PricingWidgetComponent)}
//,"component":new DynamicWidgetComponent(ProductsWidgetComponent)}
//,"component":new DynamicWidgetComponent(PromotionsWidgetComponent)},
//"component":new DynamicWidgetComponent(ReviewsWidgetComponent)},
//"component":new DynamicWidgetComponent(ShippingWidgetComponent)},
//,"component":new DynamicWidgetComponent(StoreManagementWidgetComponent)} */
